import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import GetLoanLiabilities from "Communication/ApiClasses/GetLoanLiabilitiesRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleGetLoanLiabilities(action) {
  yield put(doLoadingStart(STRINGS.LIABILITIES.API_KEYS.LOAN_GET_LIABILITIES));
  const getLoanLiabilities = new GetLoanLiabilities(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.financialId
  );
  try {
    const result = yield call(getLoanLiabilities.getData);
    yield put({
      type: actionTypes.LOAN_GET_LIABILITIES_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_GET_LIABILITIES_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.LIABILITIES.API_KEYS.LOAN_GET_LIABILITIES)
    );
  }
}

// watcher
function* getLoanLiabilitiesWatcherSaga() {
  yield takeLatest(actionTypes.LOAN_GET_LIABILITIES, handleGetLoanLiabilities);
}

export default getLoanLiabilitiesWatcherSaga;
